<template>
<div>
    <div class="ordeListrHead">
        <div class="back global_pointer" @click="goBack">
            <img src="@/assets/imgs/nav_left_icon_back.png" />
        </div>
        <van-tabs
            class="tab"
            v-model="tabIndex"
            @change="changeName"
            :ellipsis="false"
            color="#333333"
            title-active-color="#333333"
        >
            <van-tab :title="orderLan.allOrder"></van-tab>
            <van-tab :title="orderLan.waitPay"></van-tab>
            <van-tab :title="orderLan.waitSent"></van-tab>
            <van-tab :title="orderLan.waitReceive"></van-tab>
        </van-tabs>
    </div>
	<div class="order-list" :class="{ 'add-background': !orderList.length }">

		<div :class="{ 'list-box': true }" v-if="orderList.length && load">
			<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="orderLan.noDatas"
				@load="onLoad"
			>
				<order-item
					v-for="(itemOrder, index) in orderList"
					:key="itemOrder.id + index"
					:itemDetail="itemOrder"
					@cancelOrder="cancelOrder"
					@toPay="toPay"
					@deleteOrder="deleteOrder"
					@confirmDelivery="confirmDelivery"
					@contactSeller="contactSeller(itemOrder)"
				>
				</order-item>
			</van-list>
		</div>

		<div class="list-box-none" v-if="!orderList.length && load">
			<img v-lazy="emptyIcon" alt="" />
			<div class="datatips">{{ orderLan.ordertips }}</div>
		</div>
	</div>

    </div>
</template>

<script>
import { List, Tab, Tabs } from "vant";
import api from "@/api/api_list";
import OrderItem from "@/components/order/orderItem";
export default {
	components: {
		OrderItem,
		[List.name]: List,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
	},
	mixins: [],
	data() {
		return {
			orderLan: this.$t("message.order"),
			selectedLabelDefault: this.$t("message.order.allOrder"),
			tabIndex: 0,
			tabsList: [
				{
					label: this.$t("message.order.allOrder"),
				},
				{
					label: this.$t("message.order.waitPay"),
				},
				{
					label: this.$t("message.order.waitSent"),
				},
				{
					label: this.$t("message.order.waitReceive"),
				},
			],
			orderList: [],
			load: false,
			finished: false,
			loading: false,
			pageNum: 1,
			emptyIcon:
				"https://fr-static.shopshops.top/20200924/empty@2x.2cf24ea5f0d667cc.png",
		};
	},
	computed: {},
	mounted() {
		this.tabIndex = Number(this.$route.query.tabIndex);
		this.getList();
	},
	methods: {
		async getList() {
			if (this.pageNum === 1) {
				this.load = false;
			}
			const params = {
				pageNum: this.pageNum,
				pageSize: 20,
				orderStatus: this.tabIndex,
			};
			try {
				const { result, code } = await api.list_orders(params);
				if (!code) {
					let OrderStatusShow = {
						1: this.orderLan.waitPay,
						2: this.orderLan.waitSent,
						3: this.orderLan.waitReceive,
						4: this.orderLan.waitMent,
						5: this.orderLan.yetMent,
						6: this.orderLan.fackof,
					};

					result.data.forEach((item) => {
						item.orderStateDesc =
							OrderStatusShow[item.userOrderStatus];
					});
					if (this.pageNum === 1) {
						this.load = true;
						this.orderList = result.data;
					} else {
						this.loading = false;
						this.orderList = [...this.orderList, ...result.data];
					}
					if (result.data.length < 20) {
						this.finished = true;
					}
				}
			} catch (err) {}
		},
		// 加载更多
		onLoad() {
			this.pageNum++;
			this.getList();
		},
		// tab切换
		changeName() {
			this.pageNum = 1;
			this.getList();
		},
		// 取消订单
		async cancelOrder(id) {
			const { code } = await api.cancel_order({
				orderId: id,
			});
			if (!code) {
				this.pageNum = 1;
				await this.getList();
			}
		},
		// 立即支付
		async toPay({ id }) {
			this.$router.push({ path: "/repay", query: { orderId: id } });
		},
		// 删除订单
		async deleteOrder(id) {
			const { code } = await api.delete_order({ id });
			if (!code) {
				this.pageNum = 1;
				await this.getList();
			}
		},
		async confirmDelivery() {
			try {
				const { code } = await api.confirm_receipt({
					orderId: this.$route.query.orderId,
				});
				if (!code) {
					this.pageNum = 1;
					await this.getList();
				}
			} catch (error) {
				this.$toast.fail(orderLan.confirmShopFail);
			}
		},
		goBack() {
			if (this.$route.query.authLogin) {
				const urlBackName = this.$storage.get("urlBackName");
				const urlBackParam = this.$storage.get("urlBackParam");
				this.$storage.remove("urlBackName");
				this.$storage.remove("urlBackParam");
				if (!urlBackName && !urlBackParam) return;
				this.$router.replace({
					name: urlBackName,
					query: { ...urlBackParam },
				});
				return;
			}
			this.$router.go(-1);
		},
		contactSeller(item) {
			const { symbol, number } = item.miniAmountMoney;
			const { url = "" } = item.merchandiseImg;

			let data = {
				goodsName: item.merchandiseName,
				goodsId: item.id,
				goodsImageUrl: url,
				goodsMoneySymbol: symbol,
				goodsMoneyNumber: priceSeparator(Number(number).toFixed(2)),
				topicId: this.liveId,
				url: window.location.href, //地址
			};
			this.qiyuKF(data);
		},
		qiyuKF(data) {
			ysf("product", {
				show: 1,
				title: data.goodsName,
				desc: data.goodsId,
				picture: data.goodsImageUrl,
				note: `${data.goodsMoneySymbol} ${data.goodsMoneyNumber}`,
				url: data.url,
				success: function () {
					ysf.open();
				},
			});
		},
	},
};
</script>

<style scoped lang="less">
.ordeListrHead {
	// position: fixed;
	// margin: 0 0 0 12px;
	width: 100%;
	background: white;
	z-index: 10;
	display: flex;
	flex-direction: row;
	// justify-content: center;
	align-items: center;
	flex: 1;
	.back {
		img {
			width: 28px;
			height: 28px;
		}
	}
	.tab {
		width: calc(100%-28px);
	}
}
.add-background {
	background: #fff;
}
.orderWei {
	top: 23px;
}
.order-list {
	overflow-x: hidden;
	width: 100%;
	height: 100%;
	font-size: 14px;
}
.list-box {
	padding-top: 10px;
}
.listWei {
	padding-top: 95px;
}
.list-box-none {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	img {
		display: block;
		width: 132px;
		height: 76px;
		margin-bottom: 36px;
	}
	.datatips {
		font-size: 14px;
		color: #aeaeae;
	}
}
</style>
<style>
.van-tabs__line {
	background-color: rgb(81, 157, 158);
}
</style>
